import { ITableColumn, DataTableDefaultCellTemplates, DataTableEventArgs } from "../../../../components";
import { useConfirmationModalContext } from "../../../../shared/components/ModalConfirmationContext";
import { CustomerVehicleTableHeaders } from "../../../../shared/util/constant";


export default class CustomerBasicVehicleService {
    private handleRowExpandToggle(
        dtEventArgs: DataTableEventArgs,
        onRowClick: any,
        onCancelClick: () => void
    ) {
        const { rowData, dataTableState, eventData } = dtEventArgs;
        if (!dataTableState || !dataTableState.dataTable) return;
        const { rowsState } = dataTableState;
        const rowKey = rowData[dataTableState.dataTable.keyColumnName!];
        let currentRowState = rowsState[rowKey];
        if (!eventData.target?.classList?.contains('chevron-disabled')) {
            if (!currentRowState) {
                currentRowState = { expanded: eventData.expand };
            } else {
                currentRowState = { ...currentRowState, expanded: eventData.expand };
            }

            if (!currentRowState.expanded && !dataTableState.dataTable.isFormSaved) {
                rowsState[rowKey] = { expanded: true };
                dataTableState.dataTable.setExpandedRowId!(rowKey);
                rowsState[rowKey] = { expanded: false };
                dataTableState.dataTable.setExpandedRowId!(rowKey);
            }
            rowsState[rowKey] = { expanded: currentRowState.expanded };

            dataTableState.dataTable.setExpandedRowId!(
                currentRowState.expanded ? rowKey : null
            );

            if (currentRowState.expanded) {
                onRowClick(rowData, dtEventArgs.column);
            } else {
                onCancelClick();
            }
        } else {
            eventData.preventDefault();
        }
    }

    getVehicleTableColumns = (
        onRowClick: any,
        onVehicleSelect: any,
        onCancelClick: () => void,
        onRowDeleteClick?: any,
        selectedVehicleId?: string,
        tabIndex?: number
    ): ITableColumn[] => {
        return [
            {
                width: "40px",
                cellTemplate: (rowData) => (
                    <div className="d-flex justify-content-center">
                        <input
                            type="radio"
                            name="vehicleSelection"
                            checked={rowData.id === selectedVehicleId}
                            onChange={() => onVehicleSelect(rowData)}
                            className="location-radio-select"
                        />
                    </div>
                ),
                cellTdClassName: "radio-select-cell-td",
            },
            {
                tabIndex: tabIndex,
                width: "40px",
                cellTemplate: DataTableDefaultCellTemplates.RowExpander.CellTemplate,
                cellClickHandler: async (dtEventArgs: DataTableEventArgs) => {
                    this.handleRowExpandToggle(dtEventArgs, onRowClick, onCancelClick);
                },
                onKeyDownHandler: (dtEventArgs?: DataTableEventArgs) => {
                    if (!dtEventArgs) return;
                    const { eventData } = dtEventArgs;
                    if (
                        eventData.code === "Enter" || eventData.key === "Enter" ||
                        eventData.code === "Space" || eventData.key === " "
                    ) {
                        eventData.expand = true;
                        this.handleRowExpandToggle(dtEventArgs, onRowClick, onCancelClick);
                    }
                },
                cellTdClassName: "expander-cell-td",
            },
            {
                header: CustomerVehicleTableHeaders.VEHICLE_NUMBER,
                field: "vehicleNumber",
                width: "15%",
                cellTemplate: (rowData) => <span>{rowData.vehicleNumber}</span>,
            },
            {
                header: CustomerVehicleTableHeaders.YEAR,
                field: "year",
                width: "15%",
                cellTemplate: (rowData) => <span>{rowData.vehicleYear}</span>,
            },
            {
                header: CustomerVehicleTableHeaders.MAKE,
                field: "make",
                width: "25%",
                cellTemplate: (rowData) => <span>{rowData.make}</span>,
            },
            {
                header: CustomerVehicleTableHeaders.MODEL,
                field: "model",
                width: "35%",
                cellTemplate: (rowData) => <span>{rowData.model}</span>,
            },
            {
                tabIndex: tabIndex,
                width: "5%",
                cellTemplate: DataTableDefaultCellTemplates.DeleteCellTemplate.CellTemplate,
                cellClickHandler: (dtEventArgs: DataTableEventArgs) =>
                    onRowDeleteClick(dtEventArgs.rowData, dtEventArgs.column),
                onKeyDownHandler: (dtEventArgs?: DataTableEventArgs) => {
                    if (!dtEventArgs) return;
                    const { eventData } = dtEventArgs;
                    if (
                        eventData.code === "Enter" || eventData.key === "Enter" ||
                        eventData.code === "Space" || eventData.key === " "
                    ) {
                        onRowDeleteClick(dtEventArgs.rowData, dtEventArgs.column);
                    }
                },
            },
        ];
    };
}
